<template>
  <div class="projectglconfig">
    <div class="tools-btn"><el-button type="primary" size="mini" @click="addParent">添加父级</el-button></div>
    <el-table :data="tableData" height="30vh" border style="width: 100%;margin-top:10px;">
      <el-table-column prop="equipId" label="设备编号">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.equipId" disabled></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="parentId" label="父级编号" width="120">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.parentId"></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="equipName" label="设备名称" width="140">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.equipName"></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="equipModelId" label="模型" width="140">
        <template slot-scope="scope">
          <div>
            <el-select v-model="scope.row.equipModelId" @change="res => changeBattery(res, scope.$index)">
              <el-option v-for="item in modelOtions" :key="item.modelId" :label="item.modelName" :value="item.modelId"></el-option>
            </el-select>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="positionX" label="坐标X" width="140">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.positionX"></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="positionY" label="坐标Y" width="140">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.positionY"></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="positionZ" label="模型旋转Z" width="140">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.positionZ"></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="stackNum" label="堆编号" width="140">
        <template slot-scope="scope">
          <div>
            <el-select v-model="scope.row.stack" value-key="modelNum" @change="r=>changeStack(r,scope.row)">
              <el-option v-for="item in stackOtions" :key="item.modelNum" :label="item.modelNum" :value="item"></el-option>
            </el-select>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="showLevel" label="显示级别" width="120">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.showLevel"></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="showOrder" label="显示顺序" width="120">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.showOrder"></el-input></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectId" label="项目编号" width="200">
        <template slot-scope="{ row }">
          <div><el-input v-model="row.projectId" disabled></el-input></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" circle size="small" @click="saveOne(scope.row)">保存</el-button>
          <el-button type="text" size="small" @click="addOne(scope.$index, scope.row)">插入</el-button>
          <el-button type="text" class="red" size="small" @click="delOne(scope.$index, scope.row)">删除</el-button>
          <el-button type="text" size="small" @click="setBatteryClusterConfig(scope.$index, scope.row)">面板配置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      :title="panelName + '（' + currentRow.equipName + '）'"
      :visible.sync="showBatteryCluster"
      @close="closeBattery"
      :close-on-press-escape="false"
      :wrapperClosable="false"
      direction="rtl"
      size="50%"
    >
      <div class="wrap-battery">
        <div>
          <el-button class="save-btn-battery" type="primary" size="mini" @click="saveBatteryCluster">保存</el-button>
          <el-table :data="batteryClusterData" height="40vh">
            <el-table-column label="簇编号" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.cluId" disabled size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="簇名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.cluName" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header" slot-scope="scope">
                <span>是否显示</span>
                <el-switch size="mini" v-model="showAllBattery" @change="res => changeSwitch(1, res, scope.row)"></el-switch>
              </template>
              <template slot-scope="scope">
                <el-switch size="mini" v-model="scope.row.isShow"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="cluFieldsId" label="簇编号" width="140">
              <template slot-scope="scope">
                <div>
                  <el-select v-model="scope.row.cluFieldsId" @change="res => changeSn(res, scope.$index)">
                    <el-option v-for="item in cluOtions" :key="item.fieldCode" :label="item.fieldCode" :value="item.id"></el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="columnNumber" label="簇列数" width="140">
              <template slot-scope="scope">
                <div>
                  <el-select v-model="scope.row.columnNumber" @change="res => changeSn(res, scope.$index)">
                    <el-option v-for="item in cluList" :key="item.columnNumber" :label="item.columnNumber" :value="item.columnNumber"></el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="configBox(scope.$index, scope.row)">配置插箱</el-button>
                <el-button size="mini" type="text" @click="setBatteryClusterConfig2(scope.$index, scope.row)">面板配置</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="battery-box" v-if="batteryBoxData.length > 0">
          <el-button class="new-btn-battery" type="primary" size="mini">保存</el-button>
          <el-table :data="batteryBoxData" height="40vh">
            <el-table-column label="插箱编号" width="150">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.batteryBoxId" disabled></el-input>
              </template>
            </el-table-column>
            <el-table-column label="插箱名称">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.batteryBoxName"></el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header" slot-scope="scope">
                <span>是否显示</span>
                <el-switch size="mini" v-model="showAllBox" @change="res => changeSwitch(2, res, scope.row)"></el-switch>
              </template>
              <template slot-scope="scope">
                <el-switch size="mini" v-model="scope.row.isShow"></el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
    <div class="pannel" v-if="currentRow.equipName">
      <div class="title">
        <b>当前：{{ currentRow.equipName }}</b>
        <b v-if="isEquipOrBattery == 1">> {{ currentCluName }}</b>
        <el-button size="mini" type="primary" @click="addPanel">新增</el-button>
        <el-button size="mini" type="danger" @click="clearPanel">关闭</el-button>
      </div>
      <div class="wrap-bind">
        <div class="flex">
          <Bind v-for="(item, index) in panelData" :key="index" @delete="deletePanel" :panelInfo="item" :projectId="projectId" :combineId="combineId" :idx="index" @finish="setBatteryClusterConfig(0,currentRow)"></Bind>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/glconfig';
import Bind from '@/views/boss/template/components/bind';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  components: {
    Bind
  },
  data() {
    return {
      panelName: '编辑电池簇及插箱',
      isEquipOrBattery: 0, //是0设备还是1电池簇
      combineId: '', //混合ID
      showBatteryCluster: false,
      tableData: [], //数据点表单
      modelOtions: [],
      stackOtions:[],//sn编号
      cluOtions:[],//电池簇列表
      cluList:[
        {columnNumber:1},
        {columnNumber:2}
      ],
      currentRow: '',
      currentCluName: '', //当前电池簇名称
      showAllBattery: true,
      showAllBox: true,
      panelData: [],
      batteryClusterData: [], //电池簇
      batteryBoxData: [], //插箱
      fieldList: [] //模糊查询的数据集合
    };
  },
  watch: {},
  created() {
    this.searchSimulationModelList();
    this.searchStackList();
  },
  methods: {
    //切换是否显示开关
    changeSwitch(index, res, row) {
      if (index == 1) {
        if (this.batteryClusterData.length > 0) {
          this.batteryClusterData.map(item => {
            item.isShow = res;
          });
        }
        return true;
      }
      if (index == 2) {
        if (this.batteryBoxData.length > 0) {
          this.batteryBoxData.map(item => {
            item.isShow = res;
          });
        }
        return true;
      }
    },
    changeStack(res,row){
    },
    //获取sn列表
    searchStackList(){
      API.searchStackList({projectId:this.projectId}).then(res=>{
        if(res.data.code==200){
         this.stackOtions = res.data.data;
        }
        this.searchSimulationEquipments();
      }).catch(()=>{
        this.$message.error("操作失败")
      })
    },
    //切换模型列表时，更新电池簇的数据
    changeBattery(res, index) {
      let clusterData = [];
      this.modelOtions.forEach(item => {
        if (item.modelId == res) {
          clusterData = item.cellClustersBoxs;
        }
      });
      this.tableData[index].cellClustersBoxs = clusterData;
      if (clusterData && clusterData.hasOwnProperty('cellClusters')) {
        this.tableData[index].cellClustersBoxsStatus = 1;
      } else {
        this.tableData[index].cellClustersBoxsStatus = 0;
      }
      this.tableData = JSON.parse(JSON.stringify(this.tableData));
      this.currentRow = this.tableData[index];
    },
    //删除面板
    deleteSimulationPanelTemplateById(e){
      API.deleteSimulationPanelTemplateById({panelDataId:e.panelDataId}).then(res=>{
        if(res.data.code==200){
          this.panelData.splice(e.index, 1);
        }
      }).catch(()=>{
        this.$message.error("操作失败")
      })
    },
    //删除一个面板
    deletePanel(e) {
      this.$confirm('确认要删除此面板吗？', '提示', {
        confirmButtontext: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteSimulationPanelTemplateById(e);
      });
    },
    //面板配置
    setPanelConfig(index, row) {
      this.showBatteryCluster = true;
      this.currentRow = row;
      if (row.cellClustersBoxs && row.cellClustersBoxs.cellClusters) {
        this.batteryClusterData = JSON.parse(JSON.stringify(row.cellClustersBoxs.cellClusters));
      } else {
        this.batteryClusterData = [];
      }
      this.batteryBoxData = [];
      //获取电池簇列表
      this.searchCluListBySn(row.sn);
    },
    //获取电池簇编号
    searchCluListBySn(sn){
      API.searchCluListBySn({sn:sn}).then(res => {
        if (res.data.code == 200) {
          this.cluOtions = res.data.data;
        }
      });
    },
    //设备-配置电池簇和插箱
    setBatteryClusterConfig(index, row) {
      this.isEquipOrBattery = 0;
      this.currentRow = row;
      this.combineId = row.equipId;
      //获取面板id和测点数据
      this.panelData = [];
      let params = { combineId: row.equipId, projectId: this.projectId };
      API.searchSimulationPanelData(params).then(res => {
        if (res.data.code == 200) {
          this.panelData = res.data.data;
        }
      });
    },
    //电池簇-配置电池簇和插箱
    setBatteryClusterConfig2(index, c) {
      this.isEquipOrBattery = 1;
      let row = this.currentRow;
      //获取面板id和测点数据
      this.panelData = [];
      this.combineId = row.equipId + '#' + c.cluId;
      this.currentCluName = c.cluName;
      let params = { combineId: row.equipId + '#' + c.cluId, projectId: this.projectId };
      API.searchSimulationPanelData(params).then(res => {
        if (res.data.code == 200) {
          this.panelData = res.data.data;
          this.closeBattery(c);
        }
      });
    },
    //关闭电池簇弹窗
    closeBattery(c) {
      if (c) {
      }
      this.showBatteryCluster = false;
      this.batteryBoxData = [];
      this.batteryClusterData = [];
    },
    //保存电池簇
    saveBatteryCluster() {
      if (this.currentRow.cellClustersBoxs == null) {
        this.currentRow.cellClustersBoxs = {};
      }
      this.currentRow.cellClustersBoxs.cellClusters = this.batteryClusterData;
      this.saveBox();
      this.saveOne(this.currentRow);
    },
    //保存当前插箱数据
    saveBox() {
      this.batteryClusterData.batteryBox = this.batteryBoxData;
      this.currentRow.cellClustersBoxs.cellClusters = this.batteryClusterData;
    },
    //配置插箱
    configBox(index, row) {
      this.batteryBoxData = row.batteryBox;
    },
    //获取modelSize

    //保存一条
    saveOne(row) {
      let params = {};
      params.equipId = row.equipId;
      params.parentId = row.parentId;
      params.equipName = row.equipName;
      params.equipModelId = row.equipModelId;
      params.position = row.positionX + ',' + row.positionY + ',' + row.positionZ;
      params.showLevel = row.showLevel;
      params.showOrder = row.showOrder;
      params.projectId = row.projectId;
      if(row.stack && row.stack.collectorId){
        params.emsId = row.stack.collectorId;
      }
      if(row.stack && row.stack.modelNum){
        params.stackNum = row.stack.modelNum;
      }
      this.modelOtions.forEach(item=>{
        if(item.modelId==params.equipModelId){
          params.groupSize = item.modelSize;
        }
      })
      if (params.equipId) {
        this.updateOne(params);
        return true;
      }
      API.addSimulationEquipment(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchSimulationEquipments();
        }
      });
    },
    //修改一条
    updateOne(row) {
      API.updateSimulationEquipment(row).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchSimulationEquipments();
        }
      });
    },
    //插入一条
    addOne(index, row) {
      let data = {
        equipId: '',
        parentId: row.equipId,
        equipName: '',
        equipModelId: '',
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        cellClustersBoxs: { cellClusters: [] },
        showLevel: 0,
        showOrder: 0,
        projectId: this.projectId
      };
      this.tableData.splice(index + 1, 0, data);
    },
    //删除一条
    delOne(index, row) {
      this.$confirm('确认要删除此记录吗？', '提示', {
        confirmButtontext: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.equipId) {
          API.deleteSimulationEquipment({ equipId: row.equipId }).then(res => {
            if (res.data.code == 200) {
              this.$message.success('操作成功！');
            } else {
              this.$message.wraning('异常错误' + res.data.code);
            }
            this.searchSimulationEquipments();
          });
        } else {
          this.tableData.splice(index, 1);
        }
      });
    },
    //增加父级
    addParent() {
      let data = {
        equipId: '',
        parentId: 0,
        equipName: '',
        equipModelId: '',
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        cellClustersBoxs: { cellClusters: [] },
        showLevel: 0,
        showOrder: 0,
        projectId: this.projectId
      };
      this.tableData.push(data);
    },
    //增加一个模板
    addPanel() {
      this.panelData.push({});
    },
    //模型数据转换
    toTableData(data) {
      let modelSize = '';
      let tableData = [];
      data.forEach(item => {
        item.isEdit = 0;
        item.cellClustersBoxsStatus = 0;
        if (item.cellClustersBoxs) {
          item.cellClustersBoxsStatus = item.cellClustersBoxs.cellClusters.length > 0 ? 1 : 0;
        }
        modelSize = item.modelSize.split(',');
        item.modelSizeX = modelSize[0];
        item.modelSizeY = modelSize[1];
        tableData.push(item);
      });
      return tableData;
    },
    //获取模型列表
    searchSimulationModelList() {
      API.searchSimulationModelList().then(res => {
        if (res.data.code == 200) {
          let tmp = res.data.data;
          this.modelOtions = this.toTableData(tmp);
        }
      });
    },
    //获取列表
    searchSimulationEquipments() {
      let params = { projectId: this.projectId, templateId: 0 };
      API.searchSimulationEquipments(params).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          let position = [];
          let tmpItem = {};
          this.tableData = [];
          data.forEach(item => {
            tmpItem = item;
            if (item.position) {
              position = item.position.split(',');
            }
            tmpItem.positionX = position[0];
            tmpItem.positionY = position[1];
            tmpItem.positionZ = position[2];
            tmpItem.cellClustersBoxsStatus = 0;
            if (item.cellClustersBoxs && item.cellClustersBoxs.cellClusters && item.cellClustersBoxs.cellClusters.length > 0) {
              tmpItem.cellClustersBoxsStatus = 1;
            }
            if(item.stackNum){
              tmpItem.stack = {}
              tmpItem.stack.modelNum = tmpItem.stackNum
              tmpItem.stack.collectorId = tmpItem.emsId

            }
            this.tableData.push(tmpItem);
          });
        }
      });
    },
    //清空当前面板数据
    clearPanel() {
      this.currentCluName = '';
      this.currentRow = {};
      this.panelData = [];
    },
    //模糊查询绑点数据10条
    fuzzySearchFields(query) {
      let params = { projectId: this.projectId, query: query };
      API.fuzzySearchFields(params).then(res => {
        this.fieldList = [];
        if (res.data.code == 200) {
          this.fieldList = res.data.data;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.projectglconfig {
  .tools-btn {
    margin: 20px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .pannel {
    margin-top: 20px;
    .title {
      margin-bottom: 10px;
    }
    .wrap-bind {
      height: 30vh;
      overflow: auto;
      margin-bottom: 30px;
      .flex {
        display: flex;
        flex-direction: row;
      }
    }
  }
  .wrap-battery {
    margin: 20px;
    margin-top: 0px;
    .new-btn-battery {
      margin-bottom: 10px;
    }
    .save-btn-battery {
      margin-bottom: 10px;
    }
    .battery-box {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projectglconfig.vue